var gql = require("@apollo/client").gql;

const TARIFF_BY_ID = gql`
	query TariffsOne($id: Int, $providerJoin: Boolean) {
		tariffsOne(id: $id, providerJoin: $providerJoin) {
			id
			provider_id
			displayPrice
			name
			mobile_new {
				internet
				calls
				sms
				internet_type
				calls_type
				sms_type
			}
			provider {
				id
				name
				logo
				logo_2
				vip_provider
				update_date
				contacts {
					city
					site
					street
					home_office
					email
					blog
					requisites
					name_legal
					phones
					phone_support
					link
					card
				}
				quality {
					code
					name
				}
				reviews_info {
					count_total
				}
				rating {
					expert {
						final
					}
				}
				provider_settings {
					tariffs {
						button_text
					}
				}
			}
			exclusives {
				id
				name
				description
				image_24
				image_48
			}
			after {
				rule {
					code
					value
					month_cnt
					date_end
				}
				change {
					code
					name
					id
				}
				data {
					price {
						license_fee
						license_fee_month
					}
					internet {
						include_trafic_metrics {
							id
						}
						include_trafic_interval {
							id
						}
						type {
							id
						}
						speed_in
						speed_out
						excess_speed_in
						excess_speed_out
					}
					tv {
						channels
						channels_hd
					}
				}
			}
			price {
				license_fee
				license_fee_month
				system_calculation_connect
				license_fee_interval {
					code
					name
					name_short
				}
				system_calculation {
					id
					name
				}
				system_cancel_type {
					id
					name
				}
			}
			technologies {
				id
				name
			}
			internet {
				icon
				type {
					id
					name
				}
				speed_in
				include_trafic_metrics {
					id
					name
				}
				include_trafic_interval {
					id
					name
				}
				include_trafic_value
				excess_speed_in
				excess_speed_out
			}
			tv {
				channels
				channels_hd
				use_text
			}
			dody {
				image_24px
				image_48px
				name
				short_description
				full_description
				comment_tariff
				state
			}
			connection {
				price
				time
			}
			region {
				id
				name
				url
			}
			exclusive {
				priority
			}
			tvPackage {
				name
				channels {
					name: first_name
					second_name
					quality {
						name
						code
					}
				}
			}
			social_unlim {
				whatsapp
				telegram
				viber
				discord
				skype
				vk
				ok
				tiktok
				youtube
				snapchat
			}
			convergent_data {
				id
				name
				displayPrice
				mobile_new {
					internet
					internet_type
					sms
					sms_type
					calls
					calls_type
				}
				tv {
					channels
					channels_hd
				}
			}
		}
	}
`;

module.exports = TARIFF_BY_ID;
